import type { ComponentType } from 'react';
import ErrorLoader from 'components/ErrorLoader/ErrorLoader';
import Loader from 'components/Loader';
import EmptyPage from 'components/EmptyPage';

type Props<T> = T & {
  isLoading: boolean;
  isError: boolean;
  refetch: VoidFunction;
  isRefetching: boolean;
  isData?: boolean;
};

export function withPlaceholder<T>(Component: ComponentType<T>) {
  return (props: Props<T>) => {
    if (props.isLoading) return <Loader />;
    if (props.isError)
      return <ErrorLoader refetch={props.refetch} isRefetching={props.isRefetching} />;
    if (props.isData === false) return <EmptyPage />;

    return <Component {...props} />;
  };
}
